<template>
  <div class="h-window-100">
    <div class="container">
      <img src="../../public/images/app/newlogo.png" alt="" />
      <div class="login-container">
        <h4>Bem vindo ao portal iSend</h4>
        <span
          >A maneira mais simples e eficiente de você fazer a gestão
          logística.</span
        >
        <p v-if="errors_array.length">
          <span v-for="error in errors_array" style="color: red"
            >{{ "- " + error.erro }}<br
          /></span>
        </p>
        <div class="login-card">
          <label>Email</label>
          <input
            v-model="form.email"
            name="email"
            @keyup.enter="onLogin"
            type="email"
          />
          <label>Senha</label>
          <input
            v-model="form.password"
            name="password"
            @keyup.enter="onLogin"
            type="password"
          />
          <div class="bottom-info">
            <input type="checkbox" id="signed-in" />
            <label for="remember-me"> Manter logado</label>
            <a @click="onEsqueceuSenha()"><span>Recuperar a senha</span></a>
          </div>

          <button @click="onLogin()" :disabled="isDisabled">Logar</button>
          <b-spinner
            v-if="loading"
            style="margin: 15px auto 0 auto; color: #ff7810"
            label="Spinning"
          ></b-spinner>
        </div>
      </div>
      <LoginEmailTokenModal ref="loginemailtokenmodal" />
    </div>
    <footer />
  </div>
</template>
<script>
import LoginEmailTokenModal from './LoginEmailTokenModal.vue';
import {apiVersion} from "@/main";
import { resolveApiBase } from "@/shared/utils/resolveApiBase";

export default {
  components: {
    LoginEmailTokenModal,
  },
  data() {
    return {
      errors_array: [],
      errors: [],
      loading: false,
      isDisabled: false,
      form: new Form({
        email: '',
        password: '',
        user_location: {
          latitude: '',
          longitude: '',
        },
      }),
      helpForm: new Form({statusRecord: [], params: []}),
      moreParams: {},
      user_location: {
        latitude: null,
        longitude: null
      },
      error: null
    };
  },
  methods: {
    onLogin() {
      this.loading = true;
      this.isDisabled = true;
      this.errors_array = '';
      this.errors_array = [];
      this.form.user_location = this.user_location;
      axios.get(resolveApiBase(this.apiVersion) + '/sanctum/csrf-cookie', {
        withCredentials: true
      }).then(response => {
        this.form.post('/api/defineapiversion').then(response => {
          this.$store.commit('setApiVersion', response.version);
        });
        this.form.post('/api/login').then(response => {
          // verificar se tem os dois fatores
          this.helpForm.get('/api/login/dois-fatores').then(login => {
            if (login.dois_fatores == 1) {
              this.$refs.loginemailtokenmodal.onCreate();

            } else {
              this.helpForm.get('/api/usuario').then(resp => {
                // NUNCA logar `resp`: o payload de /api/usuario carrega o campo
                // `jwt` — e dele que persistJwtFromApiResponse (localSession.js)
                // extrai o bearer token da sessao. Logar aqui imprime um token
                // valido no console do navegador a cada login.
                // Obrigatório existir
                this.$store.commit('setApiVersion', resp.user.unidade_active.api_version);
                this.$store.commit('setBcliente', resp.user.bcliente_active);
                this.$store.commit('setUser', resp);
                if (this.$store.getters.logged.user.unidade_active != undefined) {
                  this.$store.commit('setUnidade', resp.user.unidade_active);
                } else {
                  this.$store.commit('setUnidade', null);
                }
                if (resp.user.bcliente_active.b_config_blogistic.cor_sistema == "1") {
                  this.site_header_color = "";
                } else if (resp.user.bcliente_active.b_config_blogistic.cor_sistema == "2") {
                  this.site_header_color = "site-header-red";
                } else if (resp.user.bcliente_active.b_config_blogistic.cor_sistema == "3") {
                  this.site_header_color = "site-header-blue";
                }
                //Dados Free
                this.$store.commit('BPlano', resp.user.bcliente_active.b_bcliente_bplano);
                // Local
                this.favorito = resp.favorito;
                this.tarefa = resp.tarefa;
                this.changelog = resp.changelog;
                if (resp.user.pessoa_fisica !== null) {
                  if (resp.user.pessoa_fisica == null) {
                    this.url_img_profile = "images/avatar/avatar-1-32.png";
                  } else {
                    this.url_img_profile = resp.user.pessoa_fisica.url_img;
                  }
                } else {
                  this.url_img_profile = "images/avatar/avatar-1-32.png";
                }
                this.$router.push('/dashboard');
                this.loading = false;
              })
                  .catch(errors => {
                    new ReturnApi(errors, this);
                    this.loading = false;
                  });

            }
          })

        }).catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          console.log(errors);
          this.errors_array = '';
          this.errors_array = [];
          this.errors = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof (errors[property]) === 'object') {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
          this.loading = false;
        });
      });
    },
    onEsqueceuSenha() {
      this.$router.push('/usuario/senha/esqueceu');
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    successCallback(position) {
      this.user_location.latitude = position.coords.latitude;
      this.user_location.longitude = position.coords.longitude;
    },
    errorCallback(error) {
      this.error = error.message;
    }
  },
  computed: {
    logo: {
      get() {
        return process.env.VUE_APP_LOGO_BIG;
      },
    },
    apiVersion: {
      get() {
        return this.$store.getters.api_version;
      },
    },
  },
  mounted() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
          this.successCallback,
          this.errorCallback
      );
    }
  },
  components: {LoginEmailTokenModal},

}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap");

.container {
  margin-left: auto;
  margin-right: auto;
  padding: 60px;
  font-family: "Roboto", sans-serif;
  width: 600px;
}

.container img {
  height: 120px;
  width: 120px;
}
.login-container h4 {
  margin-top: 30px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  font-size: 40px;
  color: #404041;
}
.login-container span {
  font-weight: 500;
  font-size: 15px;
  color: #808080;
}
.login-card {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.login-card label {
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  font-size: 15px;
  color: #404041;
}
.login-card input {
  border-radius: 18px;
  border: solid 1px #c5ced7;
  height: 30px;
  margin-bottom: 15px;
  font-size: 15px;
  padding-left: 15px;
}
.login-card input:focus-visible {
  outline: none;
}
.login-card button {
  background: linear-gradient(90deg, #ff7810 0%, #ffc705 100%);
  border: none;
  border-radius: 18px;
  height: 30px;
  font-size: 20px;
  margin-top: 30px;
}
.bottom-info {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-info a {
  margin-left: auto;
  font-size: 5px;
}
.bottom-info a span {
  font-size: 13px;
}
.bottom-info input {
  margin-bottom: 0;
  margin-right: 10px;
}
footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: linear-gradient(90deg, #ff7810 0%, #ffc705 100%);
  height: 40px;
}
@media (max-width: 550px) {
  .container {
    width: 100%;
    padding: 10px 40px;
  }
  .login-container h4 {
    font-size: 25px;
  }
}
@media (max-height: 550px) {
  footer {
    display: none;
  }
}
</style>
